module.exports = __webpack_public_path__ + "static/media/sideImage.822333c4.jpg";